// "More from this provider" row on the listing detail page -
// GET /v1/marketplace/listings filtered by seller_uid, sorted by
// subscribers.
const action = "MARKETPLACE_RELATED_BY_SELLER";
export const REQUEST  = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE  = action + '_FAILURE';
export const CLEAR    = action + '_CLEAR';

export const fetchRequest = (payload)  => ({ type: REQUEST,  payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error)    => ({ type: FAILURE,  payload: error });
export const clearState   = ()         => ({ type: CLEAR });
